export const MessageDefinitions = {
  window: {
    focus: {
      name: 'windowFocus',
      emittedWhen:
        'the user returns to the current page after the window has been blurred.',
    },
    blur: {
      name: 'windowBlur',
      emittedWhen:
        'the user changes tabs or window and the current page is blurred',
    },
    unload: {
      name: 'windowUnload',
      emittedWhen: 'the user closes the tab or navigates to a new page etc',
    },
    error: {
      name: 'windowError',
      emittedWhen:
        'an error which is able to be captured by the window event listener',
    },
    resume: {
      name: 'windowResume',
      emittedWhen:
        'The event fires when an application is retrieved from the background.',
    },
  },
  router: {
    locationChange: {
      name: 'routerLocationChange',
      emittedWhen:
        'the router has finished navigating to a new route and returns the current url',
    },
  },
  authentication: {
    stateChange: {
      name: 'authenticationStateChange',
      emittedWhen:
        'the current users authentication state changes. Returns boolean based on whether the user is now logged in or not',
    },
  },
  settings: {
    featureChange: {
      name: 'userFeaturesUpdated',
      emittedWhen: 'A user updates their features',
    },
  },
  map: {
    viewPortUpdated: {
      name: 'mapViewPortUpdated',
      emittedWhen: 'The maps viewPort is updated',
    },
    userLocationUpdated: {
      name: 'userLocationUpdated',
      emittedWhen: 'The user location is updated',
    },
    logTripStatusChange: {
      name: 'logTripStatusChange',
      emittedWhen: 'Log trips status changes (ie, start or end)',
    },
    logTripAutomaticallyEnded: {
      name: 'logTripAutomaticallyEnded',
      emittedWhen: 'When the app detects your trip automatically ended',
    },
  },
};

export default MessageDefinitions;
